import React, { useEffect } from 'react';
import { AlertTriangle, ShieldCheck, Scale, FileText } from 'lucide-react';

const Terms = () => {
  // Scroll to top when page loads
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="terms-page-container container">
      <div className="page-header">
        <h1 className="page-title"><Scale className="title-icon" /> سياسة الاستخدام وإخلاء المسؤولية</h1>
        <p className="page-subtitle">شروط وأحكام استخدام موقع أسعار الذهب</p>
      </div>

      <div className="terms-content card">
        <div className="terms-section important-notice">
          <AlertTriangle className="section-icon text-red" />
          <h2>موافقة ضمنية وإقرار</h2>
          <p>
            مرحباً بك في موقع أسعار الذهب. <strong>باستخدامك أو تصفحك لهذا الموقع، فإنك تقر بأنك قرأت وفهمت ووافقت تماماً وبشكل غير مشروط على جميع الشروط والأحكام المذكورة في هذه الصفحة.</strong> إذا كنت لا توافق على أي جزء من هذه الشروط، يُرجى التوقف عن استخدام الموقع فوراً.
          </p>
        </div>

        <div className="terms-section">
          <ShieldCheck className="section-icon text-gold" />
          <h2>1. إخلاء المسؤولية المالي والاستثماري (Financial Disclaimer)</h2>
          <p>
            المعلومات، الأسعار، المقالات، والبيانات المعروضة على هذا الموقع هي <strong>للأغراض المعلوماتية والتعليمية فقط</strong>. 
          </p>
          <ul>
            <li>لا نُقدم أي استشارات مالية، أو استثمارية، أو قانونية، أو ضريبية.</li>
            <li>المحتوى المنشور لا يُشكل بأي حال من الأحوال توصية أو دعوة صريحة أو ضمنية لشراء، أو بيع، أو تداول الذهب، أو أي أصول مالية أخرى.</li>
            <li>الاستثمار في الذهب والأسواق المالية ينطوي على مخاطر عالية، وقد يؤدي إلى خسارة رأس المال.</li>
            <li>أنت توافق على أنك تتخذ قراراتك المالية بناءً على بحثك الشخصي ومسؤوليتك الكاملة، ويُفضل دائماً استشارة مستشار مالي معتمد قبل اتخاذ أي قرار مالي.</li>
          </ul>
        </div>

        <div className="terms-section">
          <FileText className="section-icon text-primary" />
          <h2>2. دقة البيانات والأسعار</h2>
          <p>
            نحن نبذل قصارى جهدنا لضمان دقة وتحديث أسعار الذهب والمعلومات المعروضة من خلال جلبها من مصادر موثوقة عالمياً، إلا أننا:
          </p>
          <ul>
            <li>لا نضمن دقة، أو اكتمال، أو فورية هذه البيانات بشكل قاطع.</li>
            <li>الأسعار المعروضة قد تتأخر لعدة دقائق بسبب طبيعة عمل مزودي البيانات (APIs) وتقلبات الأسواق السريعة.</li>
            <li>الأسعار المعروضة تمثل السعر العالمي التقريبي وقد تختلف عن الأسعار المحلية في الأسواق ومحلات الصاغة بسبب الضرائب، الرسوم الإضافية (المصنعية)، واختلاف أسعار الصرف المحلية.</li>
            <li>الموقع وإدارته غير مسؤولين قانونياً أو أدبياً عن أي خسائر مباشرة أو غير مباشرة ناتجة عن الاعتماد على البيانات والأسعار الواردة في الموقع.</li>
          </ul>
        </div>

        <div className="terms-section">
          <ShieldCheck className="section-icon text-primary" />
          <h2>3. حقوق الملكية الفكرية</h2>
          <p>
            جميع المحتويات المنشورة على هذا الموقع، بما في ذلك المقالات المولدة، التصميم، الشعارات، والنصوص، هي ملكية حصرية لإدارة الموقع ولا يجوز نسخها، أو إعادة إنتاجها، أو توزيعها لأغراض تجارية دون الحصول على إذن كتابي مسبق.
          </p>
        </div>

        <div className="terms-section">
          <Scale className="section-icon text-primary" />
          <h2>4. التعديل على الشروط</h2>
          <p>
            نحتفظ بالحق الكامل في تعديل، أو تغيير، أو تحديث هذه الشروط وإخلاء المسؤولية في أي وقت وبدون إشعار مسبق. استمرارك في استخدام الموقع بعد أي تعديل يُعتبر موافقة منك على الشروط الجديدة.
          </p>
        </div>
        
        <div className="terms-footer">
          <p>تاريخ آخر تحديث: {new Date().toLocaleDateString('ar-EG')}</p>
        </div>
      </div>
    </div>
  );
};

export default Terms;
